const no_internet_connexion = {
  title: 'Se ha perdido la conexión a Internet',
  subtitle: 'Por favor, compruebe su conexión a Internet e inténtelo de nuevo.',
  retry: 'Reintentar',
}

export default no_internet_connexion
